// extracted by mini-css-extract-plugin
export default {"grayBanner":"GrayBanner_grayBanner__UmR8r"};